import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import FeaturedSection from './components/FeaturedSection';
import LatestUpdates from './components/LatestUpdates';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';
import { siteConfig } from '@/mocks/anime';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteConfig.name,
  url: siteConfig.url,
  description: siteConfig.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteConfig.url}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteConfig.name,
  url: siteConfig.url,
  description: siteConfig.description,
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@yinghuadm.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '樱花动漫网的资源都是免费的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，樱花动漫网上的所有动漫、电视剧和电影资源均可免费在线观看。我们致力于为动漫爱好者提供高质量的免费内容，无需注册和付费即可畅享海量资源。',
      },
    },
    {
      '@type': 'Question',
      name: '网站上的视频画质怎么样？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们提供高清画质（1080P）的视频资源，部分热门作品还支持4K超清画质。所有视频均经过精心转码优化，确保流畅的观看体验。',
      },
    },
    {
      '@type': 'Question',
      name: '网站的更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们每天都会更新最新动漫和影视资源，热门连载作品会在日本/国内播出后第一时间同步更新。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedSection />
        <LatestUpdates />
        <CategoryGrid />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}